// TOP LEVEL IMPORTS
import React from 'react';
// MEDIA
import logo from 'lib/media/heyned-logo.svg';

// EXPORTED COMPONENT
// ========================================
const Logo = ({ style }) => <img src={logo} alt="hey-ned" style={style} />;

// PROPS
// ========================================
Logo.defaultProps = {
  style: {
    height: 65,
    position: 'relative',
    top: -15,
  },
};

// EXPORT
// ========================================
export default Logo;



// WEBPACK FOOTER //
// ./src/components/common/Logo/index.js